var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7478 10.0007C6.7478 11.7784 8.20309 13.2249 9.99984 13.2249C11.7885 13.2249 13.2437 11.7784 13.2437 10.0007C13.2437 8.21479 11.7885 6.76833 9.99984 6.76833C8.20309 6.76833 6.7478 8.21479 6.7478 10.0007ZM14.7803 5.03903C16.2031 6.13802 17.4145 7.74611 18.2844 9.75823C18.3494 9.91176 18.3494 10.0895 18.2844 10.235C16.5446 14.2592 13.447 16.6673 9.99984 16.6673H9.99171C6.55268 16.6673 3.45512 14.2592 1.71528 10.235C1.65024 10.0895 1.65024 9.91176 1.71528 9.75823C3.45512 5.73398 6.55268 3.33398 9.99171 3.33398H9.99984C11.7234 3.33398 13.3576 3.93196 14.7803 5.03903ZM10.0008 12.011C11.1146 12.011 12.0252 11.1059 12.0252 9.99887C12.0252 8.88372 11.1146 7.97867 10.0008 7.97867C9.90325 7.97867 9.80569 7.98675 9.71626 8.00291C9.68374 8.8918 8.95203 9.60291 8.04959 9.60291H8.00894C7.98455 9.73221 7.96829 9.8615 7.96829 9.99887C7.96829 11.1059 8.87886 12.011 10.0008 12.011Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEye);
export default __webpack_public_path__ + "static/media/white-eye.ee4bba679820603bd8db33544d7f1297.svg";
export { ForwardRef as ReactComponent };